export default __webpack_public_path__ + "assets/images/4d2dfe9947574865c7edfd8c27695940.png";